import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { LocationModel } from "common/models/page-models/Location/location-data-model";
import { LocationMetaModel } from "common/models/page-models/Location/location-form-meta-model";
import { LocationFormDataService } from "common/services/data-services/admin/location/location-form-data.service";

@Injectable({
    providedIn: 'root'
})
export class LocationFormWidgetService extends FormWidgetService<LocationModel> {
    constructor(protected ds: LocationFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new LocationMetaModel();
        return meta.getMetaModel();
    }

    override prepareMetaModel(dataModel: DataModel, metaModel: LocationMetaModel, routeData: WidgetModel): Promise<LocationMetaModel> {
        return new Promise<LocationMetaModel>((resolve, reject) => {
            metaModel.pageTitle = dataModel.id !== 0 ?  'Update Location' : 'Add Location';
            resolve(metaModel);
        });
    }


}
